import React from "react"
import "./ShowOrders.less"
import ShowOrdersTable from "./ShowOrdersTable"

/**
 * ShowOrders
 * @constructor
 */
const ShowOrders: React.FC = () => {

  return (
    <div className="ShowOrders">
      <ShowOrdersTable />
    </div>
  )
}

export default ShowOrders 